module.exports = __webpack_public_path__ + "img/mcmasteralumni.fd6c5f6a.png";